<template>
<div v-if="current">
    <div class="panel">
        <playerUpgradeModal v-if="showPlayerUpgradeModal" :playerId=playerToUpgrade @closeMessage="showPlayerUpgradeModal = false" @updatePublished="upgradeValidated"></playerUpgradeModal>
        <messageModal v-if="showCreatedUpgradeMessage" message="Montées de niveau enregistrées" @closeMessage="showCreatedUpgradeMessage = false"></messageModal>
        <confirmModal v-if="showFirePlayerConfirmModal" message="Vous êtes sûr de vouloir renvoyer ce joueur ?" :id="playerToFire" @confirm="confirmFiringPlayer" @closeMessage="showFirePlayerConfirmModal = false"></confirmModal>
        <messageModal v-if="showFiredPlayerMessage" message="Le joueur a bien été viré comme une merde" @closeMessage="showFiredPlayerMessage = false"></messageModal>
        <confirmModal v-if="showHireJourneymanConfirmModal" message="Vous êtes sûr de vouloir recruter ce journalier ?" @confirm="confirmHiringJourneyMan" @closeMessage="showHireJourneymanConfirmModal = false"></confirmModal>
        <messageModal v-if="showHiredJourneymanMessage" message="Le journalier a été recruté" @closeMessage="showHiredJourneymanMessage = false"></messageModal>
        <team-detail-header :actions="true" :team="current"></team-detail-header>
        <regular-team-viewer v-if="current.status != 5"></regular-team-viewer>
        <season-break-viewer v-if="current.status == 5"></season-break-viewer>
        <div class="panel-content panel-top">
            <div class="row">
                <div class="large-12 columns">
                    <ul class="tabs horizontal" data-tab>
                        <li><a :class="{active : true}" @click="showTeamNews = true">  News et présentation </a></li>
                        <li><a :class="{active : !true}" @click="showTeamNews = false">Liste des matchs</a></li>
                    </ul>
                    <div v-if="showTeamNews === true">
                        <commentPanel :entity_type="teamContentType.id" :entity_id="id"></commentPanel>
                        <br>
                        <hr>
                    </div>
                    <div v-if="showTeamNews === false">
                        <br>
                        <div v-for="mr in matchReportList" >
                            <mrHeader :actions="true" class="match-header" :match="mr"></mrHeader>
                            <hr>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<div v-else>
  <spinner></spinner>
</div>
</template>

<script>
import store from '../../store/index.js'
import spinner from '../common/spinner.vue'
import messageModal from '../common/message-modal.vue'
import confirmModal from '../common/confirm-modal.vue'
import teamDetailHeader from './team-header/team-detail-header.vue'
import playerUpgradeModal from '../common/player-upgrade-modal.vue'
import player from '../../api/player.api'
import teamPurchases from '../../api/team-purchases.api'
import { mapGetters } from 'vuex'
import mrHeader from '../match-reports/mr-header.vue'
import commentPanel from '../common/comment-panel.vue'
import regularTeamViewer from './team-viewers/regular-team-viewer.vue'
import seasonBreakViewer from './team-viewers/season-break-viewer/season-break-viewer.vue'

export default {
  name: 'teamDetail',
  components: {
    spinner,
    teamDetailHeader,
    playerUpgradeModal,
    messageModal,
    commentPanel,
    confirmModal,
    mrHeader,
    regularTeamViewer,
    seasonBreakViewer
  },
  props: {
    'id': Number
  },
  data () {
    return {
      showPlayerUpgradeModal: false,
      showCreatedUpgradeMessage: false,
      showFirePlayerConfirmModal: false,
      showFiredPlayerMessage: false,
      showHireJourneymanConfirmModal: false,
      showHiredJourneymanMessage: false,
      playerToUpgrade: null,
      playerToFire: null,
      journeymanToHire: null,
      showTeamNews: true
    }
  },
  computed:
  {
    ...mapGetters([
      'matchReportList',
      'currentUser'
    ]),
    nbColumns: function () {
      if (this.current.league.id === 1) {
        return 17
      }
      return 16
    },
    current: function () {
      return store.getters.detailedTeam
    },
    needAction: function () {
      if (this.current.status === 2) {
        return true
      }
      return false
    },
    canPerformAction: function () {
      if (this.current.user.id === this.currentUser.id || this.currentUser.is_superuser) {
        return true
      }
      return false
    },
    wounded: function () {
      let woundedCpt = 0
      this.current.players.forEach(player => {
        if (player.miss_next_game) {
          woundedCpt++
        }
      })
      return woundedCpt
    },
    journeymens: function () {
      let journeymensCpt = 0
      this.current.players.forEach(player => {
        if (player.is_journeyman) {
          journeymensCpt++
        }
      })
      return journeymensCpt
    },
    playersCost: function (onlyPlaying = true) {
      let playerCost = 0
      this.current.players.forEach(player => {
        if (!onlyPlaying || !player.miss_next_game) {
          playerCost += (player.base_cost + player.evolution_cost)
        }
      })
      return playerCost
    },
    teamContentType: function () {
      return store.getters.getContent('league_manager', 'team')
    }
  },
  created () {
    store.dispatch('hideLeaguePanel')
    store.dispatch('activateFullSizePage')
    store.dispatch('getDetailedTeam', this.id.toString())
    store.dispatch('getContentType')
    store.dispatch('getMatchReportForTeam', this.id.toString())
  },
  destroyed () {
    store.dispatch('invalidateDetailedTeam')
  },
  methods: {
    getUpgradeName (upgrade) {
      if (upgrade.status === 0) {
        return ''
      }
      if (upgrade.value === 0 || upgrade.value === 1) {
        return upgrade.skill
      }
      if (upgrade.value === 2) {
        return '+1 M'
      }
      if (upgrade.value === 3) {
        return '+1 Ar'
      }
      if (upgrade.value === 4) {
        return '+1 Ag'
      }
      if (upgrade.value === 5) {
        return '+1 F'
      }
    },
    getUpgradeStyle (upgrade) {
      if (upgrade.type === 0) {
        return 'upgrade base'
      }
      if (upgrade.type === 1) {
        if (upgrade.value === 0) {
          return 'upgrade simple'
        }
        if (upgrade.value === 1) {
          return 'upgrade double'
        }
        if (upgrade.value > 1) {
          return 'upgrade stats'
        }
      }
    },
    getDowngrades (player) {
      if (player.downgrades === null) {
        return ''
      }
      let dwngrd = ''
      if (player.downgrades['M'] !== 0) {
        dwngrd += '-' + player.downgrades['M'].toString(10) + 'M '
      }
      if (player.downgrades['F'] !== 0) {
        dwngrd += '-' + player.downgrades['F'].toString(10) + 'F '
      }
      if (player.downgrades['Ag'] !== 0) {
        dwngrd += '-' + player.downgrades['Ag'].toString(10) + 'Ag '
      }
      if (player.downgrades['Ar'] !== 0) {
        dwngrd += '-' + player.downgrades['Ar'].toString(10) + 'Ar '
      }
      return dwngrd
    },
    firePlayer ($event) {
      this.playerToFire = $event.target.id
      this.showFirePlayerConfirmModal = true
    },
    confirmFiringPlayer () {
      player.api.deletePlayer(this.playerToFire)
      .then(response => {
        this.showFirePlayerConfirmModal = false
        this.showFiredPlayerMessage = true
        store.dispatch('getDetailedTeam', this.id.toString())
      },
      error => {
        console.log('erreur impossible to fire player ')
        console.log(error)
      })
    },
    hireJourneyman ($event) {
      this.journeymanToHire = $event.target.id
      this.showHireJourneymanConfirmModal = true
    },
    confirmHiringJourneyMan () {
      let playerToHire = this.current.players.find(pl => pl !== undefined && pl.id === parseInt(this.journeymanToHire, 10))

      let purchase = {}
      let journeymen = []
      let journeyman = {}
      journeyman.id = playerToHire.id
      journeyman.name = playerToHire.name
      journeyman.num = playerToHire.num
      journeymen.push(journeyman)
      purchase.journeymen = journeymen
      teamPurchases.api.publishTeamPurchases(this.id, purchase)
      .then(response => {
        this.showHireJourneymanConfirmModal = false
        this.showHiredJourneymanMessage = true
        store.dispatch('getDetailedTeam', this.id.toString())
      },
      error => {
        console.log('erreur impossible to hire journeyman ')
        console.log(error)
      })
    },
    getRosterIcon (item) {
      return '/static/imgs/team-icons/' + item.ref_roster.name + '.png'
    },
    upgradeValidated () {
      store.dispatch('getDetailedTeam', this.id.toString())
      this.showCreatedUpgradeMessage = true
      this.showPlayerUpgradeModal = false
    },
    upgradePlayer ($event) {
      this.playerToUpgrade = $event.target.id
      this.showPlayerUpgradeModal = true
    }
  }

}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.roster{
    font-weight: 300;
}

.roster tr:nth-of-type(odd) {
    transition: background-color 0.15s;
    background-color: #E9EDEF;
}

.roster tr:nth-of-type(even) {
    background-color: #ffffff;
}

/***** gestion des formats de cellules*/

thead tr th {
    background-color: #ffffff;
    text-align: center;
    font-weight: 200;
    font-size:0.7rem;
    padding-left: 0.3rem;
    padding-right: 0.3rem;
}

.roster tr td{
    padding: 0.5rem 0rem;
    text-align: center;
    font-size:0.6rem;
}

.star tr td{
    padding: 0.5rem 0rem;
    text-align: center;
    font-size: 0.8rem;
    font-weight: 500;
    background-color: #E9EDEF;

}

.roster tr td.sous-total{
    font-weight: 600;
    padding: 0.4rem 0rem;
}


.roster tr td.sous-total.right{
  margin-right: 0;
  padding-right:0;
  text-align: right;
}

button.row{
    margin-left: 0.4rem;
}

.panel-top {
    padding-top: 0rem;
}

.miss {
    text-decoration: line-through;
}
.tabs {
    border-style: none;
    padding-top: 1.2rem;
    border-bottom: 1px solid #cacaca;
    padding-bottom: 0.4rem
}


.tabs li{
    float: left;
    margin-left : 0rem;
    /* padding : 0.4rem 0.8rem ; */
    margin-right : 0rem;
    /* position: relative; */
    bottom: -1px;
    margin-bottom:0rem;
}

.tabs li a {
    color:#596374;
    font-weight: 400;
    transition: background-color 0.5s,border-top-color 0.5s;
    padding : 0.4rem 0.8rem ;
}

.tabs > li a:hover {
    border-top: 2px solid #2c3e50;
}

.tabs > li a.active {
    border: 1px solid #cacaca;
    border-bottom: 3px solid white;
    border-top: 2px solid #2c3e50;
    position: relative;
}

.upgrade {
  font-weight: 600;
}

.base {
  color: #1a6b3a
}

.simple {
  color: #000000
}

.double {
  color: #0e648e
}

.stats {
  color: #882e8e
}

.down {
  color: #8e2625
}

.inner-title{
  padding-top: 1rem;
  margin-bottom: 0.3rem;
  text-align: left;
  font-size: 1.3rem;
  font-weight: 400;
}
</style>



// WEBPACK FOOTER //
// team-detail.vue?34d37524